module.exports = __webpack_public_path__ + "img/logo2.159780fb.png";